import { Server, Activity, LayoutGrid, Cpu } from 'lucide-react'
import RackEquipment from './RackEquipment'
import RackComponents from './RackComponents'
import RackLayoutView from './RackLayoutView'
import { ActivityLogs } from '../Shared'

export const tabs = () => [
    {
        label: 'Equipment in Rack',
        value: 'equipment',
        startIcon: <Server className="text-primary w-4 h-4" />,
        component: <RackEquipment />,
    },
    {
        label: 'Components in Rack',
        value: 'components',
        startIcon: <Cpu className="text-primary w-4 h-4" />,
        component: <RackComponents />,
    },
    {
        label: 'Rack Layout',
        value: 'layout',
        startIcon: <LayoutGrid className="text-primary w-4 h-4" />,
        component: <RackLayoutView />,
    },
    {
        label: 'Activity Logs',
        value: 'logs',
        startIcon: <Activity className="text-primary w-4 h-4" />,
        component: <ActivityLogs entityType="rack" />,
    },
]
